import {
    useState,
    useEffect,
    useCallback,
    useRef
} from 'react';
import window from 'window-or-global';

const PENDING_TIMEOUT = 3000;

export const INTERVIEW_STATUS = {
    IDLE: 'idle',
    PENDING: 'pending',
    COMPLETED: 'completed',
    ERROR: 'error'
};

export const useInterviewState = (props) => {
    const {
        configState,
        locale,
        location,
        fetchProfileUpdates,
        pullTaxProfile,
        refreshTaxInterviewUrl,
        getConsentTaxInterviewUrl,
        traceTakeInterview,
        resetInterviewCurrentUrl,
        resetInterviewFailed
    } = props;

    const [status, setStatus] = useState(INTERVIEW_STATUS.IDLE);
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const [exitConfirmed, setExitConfirmed] = useState(false);

    const startInterview = useCallback(() => {
        const {isRetake, prizeId} = location.state || {};
        if (isRetake) {
            // retake personal tax interview
            refreshTaxInterviewUrl(locale);
        } else {
            // sign in tax interview with prize id
            getConsentTaxInterviewUrl({locale, prizeId});
        }
        traceTakeInterview();
    }, [location.state]);

    const exitConfirmedCallback = useCallback(() => {
        setStatus(INTERVIEW_STATUS.PENDING);
        setTimeout(() => {
            setShouldRedirect(true);
            setExitConfirmed(true);
            setStatus(INTERVIEW_STATUS.COMPLETED);
            fetchProfileUpdates();
        }, PENDING_TIMEOUT);
    }, [fetchProfileUpdates]);

    const isRetakeRef = useRef(location.state?.isRetake);

    useEffect(() => {
        isRetakeRef.current = location.state?.isRetake;
    }, [location.state]);

    const receiveMessage = useCallback((event) => {
        if (!exitConfirmed &&
            event.origin === configState.tiOrigin &&
            event.data === 'exitConfirmed') {
            if (isRetakeRef.current) {
                pullTaxProfile();
            }
            exitConfirmedCallback();
        }
    }, [exitConfirmed, configState.tiOrigin, exitConfirmedCallback, pullTaxProfile]);

    useEffect(() => {
        startInterview();
        window.addEventListener('message', receiveMessage, false);

        return () => {
            resetInterviewFailed();
            window.removeEventListener('message', receiveMessage, false);
            resetInterviewCurrentUrl();
        };
    }, [startInterview, receiveMessage, resetInterviewFailed, resetInterviewCurrentUrl]);

    return {
        status,
        shouldRedirect,
        exitConfirmed,
        startInterview,
        exitConfirmedCallback
    };
};
